import { render, staticRenderFns } from "./SurveyJSComponent.vue?vue&type=template&id=e5ba9e3a&scoped=true"
import script from "./SurveyJSComponent.vue?vue&type=script&lang=ts"
export * from "./SurveyJSComponent.vue?vue&type=script&lang=ts"
import style0 from "./SurveyJSComponent.vue?vue&type=style&index=0&id=e5ba9e3a&prod&lang=scss&scoped=true"
import style1 from "./SurveyJSComponent.vue?vue&type=style&index=1&id=e5ba9e3a&prod&lang=scss&global=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5ba9e3a",
  null
  
)

export default component.exports